<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>{{
          user.tipo == "representante" ? "Pedidos" : "Meus Pedidos"
        }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn fab small color="primary lighten-4" @click="tooglePesquisa">
          <v-icon>search</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card>
        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa">
            <v-col cols="12" class="pa-2">
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                dark
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                background-color="primary lighten-2"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-container fluid class="pa-3 py-0">
          <v-row v-show="rodada.id">
            <v-col class="red lighten-5 red--text" style="display: flex">
              <span>{{ rodada.nome }}</span>
              <v-spacer />
              <v-chip
                v-if="rodada && !rodada.permitir_pedidos"
                small
                color="red"
                text-color="white"
                style="min-width: 112px"
                >Apenas consulta</v-chip
              >
            </v-col>
          </v-row>

          <v-row dense class="justify-end pb-2">
            <v-col
              class="px-2"
              cols="12"
              sm="2"
              v-if="user.tipo == 'representante'"
            >
              <v-text-field
                :value="valorPendentes | valorBR"
                readonly
                hide-details
                label="Pendentes"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="red"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidosPendentes }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>

            <v-col
              class="px-2"
              cols="12"
              sm="2"
              v-if="user.tipo == 'representante'"
            >
              <v-text-field
                :value="valorEntregues | valorBR"
                readonly
                hide-details
                label="Entregues"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="green"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidosEntregues }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>

            <v-col
              class="px-2"
              cols="12"
              sm="2"
              v-if="user.tipo == 'representante'"
            >
              <v-text-field
                :value="valorEnviados | valorBR"
                readonly
                hide-details
                label="Enviados"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="blue"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidosEnviados }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>

            <v-col class="px-2" cols="12" sm="2">
              <v-text-field
                :value="valorGeral | valorBR"
                readonly
                hide-details
                label="Total"
                type="text"
              >
                <template v-slot:append>
                  <v-chip
                    label
                    color="primary"
                    text-color="white"
                    class="mb-1 px-3"
                    style="height: 24px"
                  >
                    <b>{{ quantidadePedidos }}</b>
                  </v-chip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>

        <v-divider />

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="pedidos_clientes"
          :loading="loading"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
          :items-per-page="30"
          :footer-props="{
            itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
            itemsPerPageText: '',
          }"
        >
          <template v-slot:item.id="{ item }">
            <v-chip
              label
              class="py-1"
              style="width: 80px; justify-content: center"
              >{{ item.id }}</v-chip
            >
          </template>
          <template v-slot:item.data="{ item }">{{
            item.data | dataBR
          }}</template>
          <template
            v-slot:item.status="{ item }"
            v-if="user.tipo == 'representante' || user.tipo == 'cliente'"
          >
            <v-chip
              label
              color="gray"
              text-color="black"
              small
              v-if="item.status == 0"
            >
              <span style="cursor: pointer;">Pendente</span>
            </v-chip>

            <v-chip label color="primary" dark small v-if="item.status == 1">
              <span style="cursor: pointer;">Revisado</span>
            </v-chip>

            <v-chip label color="red" dark small v-if="item.status == 5">
              <span style="cursor: pointer;">Cancelado</span>
            </v-chip>

            <v-chip
              label
              color="green"
              text-color="white"
              small
              pa-1
              v-if="item.status == 3"
              @click="abrirDialogoDesfazerEntrega(item)"
            >
              <span style="cursor: pointer;">Entregue</span>
            </v-chip>

            <v-chip
              label
              color="blue"
              text-color="white"
              small
              pa-1
              v-if="item.status == 4"
            >
              <span style="cursor: pointer;">Enviado</span>
            </v-chip>
          </template>
          <template v-slot:item.valor_liquido="{ item }">{{
            item.valor_liquido | valorBR
          }}</template>
          <template v-slot:item.valor="{ item }">{{
            item.valor | valorBR
          }}</template>
          <template v-slot:item.acoes="{ item }">
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>

              <v-list dense>
                <v-list-item
                  v-if="user.tipo == 'cliente'"
                  @click="detalharPedidoCliente(item)"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">mdi-text-box-check-outline</v-icon
                    >Detalhar
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="user.tipo == 'representante'"
                  @click="detalharPedido(item)"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">mdi-format-list-checkbox</v-icon
                    >Detalhar
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="
                    item.status != 5 &&
                      ((user.tipo == 'cliente' && item.status == 0) ||
                        (user.tipo == 'representante' && item.status == 0))
                  "
                  @click="abrirDialogoCancelamento(item)"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">mdi-close</v-icon>Cancelar
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  @click="abrirDialogoEntrega(item)"
                  v-if="user.tipo == 'representante' && item.status == 1"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">local_shipping</v-icon>Informar Entrega
                  </v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-if="user.tipo == 'cliente'"
                  @click="abrirDialogoImpressao(item)"
                >
                  <v-list-item-title>
                    <v-icon class="mr-4">mdi-printer</v-icon>Imprimir
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>

      <as-dialogo
        ref="dialogoDetalhePedidos"
        title="Detalhe de Pedido"
        max-width="960px"
      >
        <v-card>
          <v-data-table
            :headers="headers_pedidos"
            :items="pedidos"
            :loading="loading"
            no-data-text="Sem registros"
            no-results-text="Sem registros"
            loading-text="Carregando dados..."
            hide-default-footer
            :footer-props="{
              itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
              itemsPerPageText: '',
            }"
          >
            <template v-slot:item.status="{ item }">
              <v-chip
                label
                color="gray"
                text-color="black"
                small
                v-if="item.status == 0"
              >
                <span style="cursor: pointer;">Pendente</span>
              </v-chip>

              <v-chip label color="primary" dark small v-if="item.status == 1">
                <span style="cursor: pointer;">Revisado</span>
              </v-chip>

              <v-chip
                label
                color="green"
                text-color="white"
                small
                pa-1
                v-if="item.status == 3"
              >
                <span style="cursor: pointer;">Entregue</span>
              </v-chip>

              <v-chip
                label
                color="blue"
                text-color="white"
                small
                pa-1
                v-if="item.status == 4"
              >
                <span style="cursor: pointer;">Enviado</span>
              </v-chip>
            </template>

            <template v-slot:item.valor_liquido="{ item }">
              <td>{{ item.valor_liquido | valorBR }}</td>
            </template>

            <template v-slot:item.acoes="{ item }">
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="$router.push('pedidos/' + item.id + '/editar')"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon>grading</v-icon>
                    </v-btn>
                  </template>
                  <span>Revisar</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </v-card>

        <!-- <div slot="botoes">
          <v-btn color="white" @click="$refs.dialogoDetalhePedidos.fechar()"
            >Cancelar</v-btn
          >
        </div> -->
      </as-dialogo>

      <as-dialogo
        ref="dialogoDetalhePedidoCliente"
        title="Detalhamento de Pedido"
        max-width="960px"
        :modal="false"
      >
        <PedidosClientesDetalhes :pedido_cliente_id="pedido_cliente.id" />

        <div slot="botoes" class="pa-2">
          <v-btn
            depressed
            color="primary"
            @click="fechardialogoDetalhePedidoCliente"
            >Fechar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoEntrega"
        title="Entregar Pedido"
        max-width="440px"
        hideCloseButton
        hideDivider
      >
        <v-label>Deseja confirmar a entrega desse pedido?</v-label>
        <div slot="botoes">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoEntrega.fechar()"
            :disabled="entregando"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="entregarPedido"
            :disabled="entregando"
            :loading="entregando"
            >Confirmar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoImpressao"
        title="Imprimir"
        max-width="440px"
        hideCloseButton
        hideDivider
      >
        <v-label>Deseja imprimir este pedido?</v-label>
        <div class="d-flex pt-8" style="justify-content: flex-end">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoImpressao.fechar()"
            :disabled="imprimindo"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="primary"
            @click="imprimirPedido"
            :disabled="imprimindo"
            :loading="imprimindo"
            >Imprimir</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoCancelamento"
        title="Cancelar Pedido"
        max-width="440px"
        hideCloseButton
      >
        <v-label>Deseja confirmar o cancelamento desse pedido?</v-label>
        <div class="d-flex pt-8" style="justify-content: flex-end">
          <v-btn
            depressed
            class="mr-4"
            @click="$refs.dialogoCancelamento.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="error"
            @click="cancelarPedido"
            :disabled="cancelando"
            :loading="cancelando"
            >Confirmar</v-btn
          >
        </div>
      </as-dialogo>
    </v-card>
  </v-container>
</template>

<script>
import ServicePedidos from "@/services/pedidos.js";
import PedidosClientesDetalhes from "./PedidosClientesDetalhes.vue";
import ServiceImpressoes from "@/services/impressoes.js";

export default {
  name: "PedidosClientesLista",
  components: {
    PedidosClientesDetalhes,
  },
  data() {
    return {
      loading: false,
      user: {},
      pesquisa: "",
      exibirPesquisa: false,
      headers: [],
      pedidos_clientes: [],
      pedido_cliente: {},
      rodada: {},
      pedidos: [],
      imprimindo: false,
      headers_pedidos: [
        {
          text: "Número",
          value: "id",
          width: "5%",
          align: "left",
        },
        {
          text: "Cliente",
          value: "cliente_nome",
          width: "35%",
        },
        {
          text: "Fornecedor",
          value: "fornecedor_nome",
          width: "35%",
          align: "left",
        },
        {
          text: "Status",
          value: "status",
          width: "10%",
          align: "center",
        },
        {
          text: "Valor",
          value: "valor_liquido",
          width: "10%",
        },
        {
          text: "",
          value: "acoes",
          width: "5%",
          sortable: false,
          align: "center",
        },
      ],
      headers_produtos: [
        { text: "Descrição", value: "descricao", width: "35%" },
        { text: "Quantidade", value: "quantidade", width: "15%" },
        { text: "Valor", value: "valor", width: "15%" },
        { text: "Subtotal", value: "subtotal", width: "15%" },
        { text: "Entrega", value: "entrega", width: "20%" },
      ],
      produtos_entregas: [],
      entregando: false,
      cancelando: false,
    };
  },
  mounted() {
    this.rodada = JSON.parse(localStorage.getItem("rodada")) || [];
    this.user = JSON.parse(localStorage.getItem("user"));

    if (this.user.tipo == "representante") {
      this.headers = [
        { text: "Número", value: "id", width: "5%", align: "left" },
        { text: "Cliente", value: "cliente_nome", width: "40%" },
        { text: "Data", value: "data", width: "15%" },
        { text: "Status", value: "status", width: "15%", align: "center" },
        {
          text: "Valor",
          value: this.$store.state.rodada.id ? "valor_liquido" : "valor",
          width: "10%",
          align: "right",
        },
        {
          text: "",
          value: "acoes",
          width: "5%",
          sortable: false,
          align: "center",
        },
      ];
    } else if (this.user.tipo == "cliente") {
      this.headers = [
        { text: "Número", value: "id", width: "5%", align: "left" },
        { text: "Loja", value: "cliente_nome", width: "40%" },
        { text: "CNPJ", value: "cnpj", width: "20%" },
        { text: "Data", value: "data", width: "10%" },
        { text: "Status", value: "status", width: "10%", align: "center" },
        { text: "Valor", value: "valor", width: "10%", align: "right" },
        {
          text: "",
          value: "acoes",
          width: "5%",
          sortable: false,
          align: "center",
        },
      ];
    }

    this.listar();
  },
  methods: {
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async listar() {
      try {
        this.loading = true;
        let response_pedidos = await ServicePedidos.listar();
        this.pedidos_clientes = response_pedidos.data.pedidos;
      } catch (error) {
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
    async detalharPedido(pedido_cliente) {
      try {
        this.loading = true;
        let pedidos_response = await ServicePedidos.detalharPedido(
          pedido_cliente.id
        );
        this.pedidos = pedidos_response.data.pedidos;

        this.$refs.dialogoDetalhePedidos.abrir();
      } catch (error) {
        this.$eventbus.erro(error.response.data.msg);
      } finally {
        this.loading = false;
      }
    },
    async detalharPedidoCliente(pedido_cliente) {
      this.pedido_cliente = this.clone(pedido_cliente);
      this.$refs.dialogoDetalhePedidoCliente.abrir();
    },
    fechardialogoDetalhePedidoCliente() {
      // this.produtos_entregas = [];
      this.$refs.dialogoDetalhePedidoCliente.fechar();
    },
    abrirDialogoEntrega(pedido_cliente) {
      this.pedido_cliente = pedido_cliente;
      this.$refs.dialogoEntrega.abrir();
    },
    async entregarPedido() {
      try {
        this.entregando = true;
        await ServicePedidos.entregarPedidoCliente(this.pedido_cliente.id);
        this.pedido_cliente.status = 3;
        this.$eventbus.notificar("Pedido entregue com sucesso");
      } catch (error) {
        this.$eventbus.erro("Erro ao entregar o pedido");
      } finally {
        this.$refs.dialogoEntrega.fechar();
        this.entregando = false;
        this.pedido_cliente = {};
      }
    },
    abrirDialogoImpressao(pedido) {
      this.pedido = pedido;
      this.$refs.dialogoImpressao.abrir();
    },
    async imprimirPedido() {
      try {
        this.imprimindo = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.imprimirPedido({
          impressao,
          pedido_id: this.pedido.id,
          rodada_id: this.$store.state.rodada.id,
        });

        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão"
          );
        }

        // let pdf = await ServiceImpressoes.imprimirPedidoCliente({
        //   impressao,
        //   pedido_cliente_id: this.pedido_cliente.id,
        //   rodada_id: this.$store.state.rodada.id,
        // });
      } catch (error) {
        this.$eventbus.erro("Erro ao imprimir este pedido");
      } finally {
        this.imprimindo = false;
        this.$refs.dialogoImpressao.fechar();
      }
    },
    abrirDialogoCancelamento(pedido_cliente) {
      this.pedido_cliente = pedido_cliente;
      this.$refs.dialogoCancelamento.abrir();
    },
    async cancelarPedido() {
      try {
        this.cancelando = true;
        if (this.user.tipo == "representante" || this.user.tipo == "cliente") {
          await ServicePedidos.cancelarPedidoCliente(this.pedido_cliente.id);
        }
        this.pedido_cliente.status = 5;
        this.$eventbus.notificar("Pedido cancelado com sucesso");
      } catch (error) {
        this.$eventbus.erro("Erro ao cancelar o pedido");
      } finally {
        this.$refs.dialogoCancelamento.fechar();
        this.cancelando = false;
        this.pedido_cliente = {};
      }
    },
  },
  computed: {
    quantidadePedidos() {
      let qtd_pedidos = 0;

      this.pedidos_clientes.forEach((pedido, index) => {
        if (pedido.status != 5) {
          qtd_pedidos++;
        }
      });

      return qtd_pedidos;
    },
    valorGeral() {
      let valor_total = 0;

      valor_total = this.pedidos_clientes.reduce((soma, pedido) => {
        if (pedido.status != 5) {
          return soma + pedido.valor_liquido;
        } else {
          return soma;
        }
      }, 0);

      return valor_total;
    },
    quantidadePedidosEntregues() {
      let qtd_pedidos_entregues = 0;

      this.pedidos_clientes.forEach((pedido, index) => {
        if (pedido.status == 3) {
          qtd_pedidos_entregues++;
        }
      });

      return qtd_pedidos_entregues;
    },
    valorEntregues() {
      let valor_total_entregues = 0;

      valor_total_entregues = this.pedidos_clientes.reduce((soma, pedido) => {
        if (pedido.status == 3) {
          return soma + pedido.valor;
        } else {
          return soma;
        }
      }, 0);

      return valor_total_entregues;
    },
    quantidadePedidosEnviados() {
      let qtd_pedidos_enviados = 0;

      this.pedidos_clientes.forEach((pedido, index) => {
        if (pedido.status == 4) {
          qtd_pedidos_enviados++;
        }
      });

      return qtd_pedidos_enviados;
    },
    valorEnviados() {
      let valor_total_enviados = 0;

      valor_total_enviados = this.pedidos_clientes.reduce((soma, pedido) => {
        if (pedido.status == 4) {
          return soma + pedido.valor;
        } else {
          return soma;
        }
      }, 0);

      return valor_total_enviados;
    },
    quantidadePedidosPendentes() {
      let qtd_pedidos_pendentes = 0;

      this.pedidos_clientes.forEach((pedido, index) => {
        if (pedido.status == 0 || pedido.status == 1) {
          qtd_pedidos_pendentes++;
        }
      });

      return qtd_pedidos_pendentes;
    },
    valorPendentes() {
      let valor_total_pendentes = 0;

      valor_total_pendentes = this.pedidos_clientes.reduce((soma, pedido) => {
        if (pedido.status == 0 || pedido.status == 1) {
          return soma + pedido.valor;
        } else {
          return soma;
        }
      }, 0);

      return valor_total_pendentes;
    },
  },
};
</script>

<style></style>
